import React, { createContext, useState, useCallback } from 'react';
import { apiConst } from '../constant/constant';
import { serverGet } from '../../middleware/http';

export const MessageContext = createContext();

export const MessageProvider = ({ children }) => {
    const [messageCount, setMessageCount] = useState(null);

    const getUnreadMessageCount = useCallback(() => {
        serverGet(apiConst.getUnreadMessageCount).then((res) => {
            try {
                if (res.status === 1) {
                    setMessageCount(res.data.unreadMessageCount);
                }
            } catch (error) {
                console.log(error);
            }
        });
    }, []);

    return (
        <MessageContext.Provider value={{ messageCount, getUnreadMessageCount }}>
            {children}
        </MessageContext.Provider>
    );
};
